var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGhana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_920_80",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_920_80",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAABMElEQVR4nO2VvUoDQRSF76vMOmCS2UHLLWxMLCziX2Nl3kJra5u1iGCthUIkYCc2YfEJbBa08O8R7AJTHJlFdCGWG3cnnA8OXO4sO3Pm3pkRIYQQQhaBXAQhSWhAWAGwhcrU3RI5D7HUv6s5r1EJ+CFzmUXVeroyeL42lf/XZfZ/DAwPl3F21ArXwHZ3CTs9HYaB6cTi8cL86OG8gyhShXxcHvPfNs6AyyzuTttYjSMopf6U7SjcnrSbWQH3rfdxjL0NPbP4/rrGyyhubgu5kt5uzIwBn6tyDpmngcvjVrHoFRMV8rHPBWPgoK+x29N4HRl8jGPsb2oMtnQYBj7vbXH3Tye//e5jn/NjczOQpGsISUIDKSsAtlCZulsi4SFO69/VhNdoGvBDRgghhEiAfAGmc1/VQOwFZAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGhana);
export default __webpack_public_path__ + "static/media/ghana.3649f84f4aae1c90eda5dcae5bff208a.svg";
export { ForwardRef as ReactComponent };